/**
 * The width math both provider buttons share.
 *
 * One place, so `apps/app` and `apps/admin` cannot end up with buttons of
 * different widths sitting on two screens that are meant to read the same.
 */

/**
 * The widest a provider button may be drawn.
 *
 * Google's renderButton caps `width` at 400. Apple's own rendered button caps
 * at 375. One number for both keeps the two buttons the same width when they
 * sit stacked, which is the only way the pair reads as one group.
 */
export const PROVIDER_BUTTON_MAX_WIDTH_PX = 375;

/**
 * Used when the container has not been laid out yet and measures 0 — which is
 * every render under happy-dom, and the first paint in a real browser.
 */
export const PROVIDER_BUTTON_FALLBACK_WIDTH_PX = 320;

export function clampProviderButtonWidth({
  containerWidthPx,
}: {
  containerWidthPx: number;
}): number {
  if (!Number.isFinite(containerWidthPx) || containerWidthPx <= 0) {
    return PROVIDER_BUTTON_FALLBACK_WIDTH_PX;
  }

  // There is deliberately no lower clamp above zero. A container narrower than
  // the fallback gets its own width back, never more, which is what keeps a
  // 320px phone free of horizontal scroll.
  return Math.round(Math.min(containerWidthPx, PROVIDER_BUTTON_MAX_WIDTH_PX));
}
